var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuttrema-layout-default-slide',{staticClass:"is-lighter"},[_c('template',{slot:"collapsed-menu-top-brand"},[_c('nuttrema-brand-image',{attrs:{"hide-in-expanded":""}})],1),_vm._v(" "),_c('nuttrema-registration-carousel',{staticClass:"expanded-menu-level-zero is-expanded",attrs:{"slot":"expanded-menu-level-zero"},slot:"expanded-menu-level-zero"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a48d638","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/layout-set/public/layout-set-public-register-instance.vue
// module id = 2982
// module chunks = 0